import authService from '../../services/authService';
const debug = false;

export default async function (requestConfig) {

  const { url, method, params } = requestConfig;

  if(debug) {
    console.log(`HTTP ${method} ${url.split('/').pop()}`, params)
  }

  // users with admin role can impersonate being in a different account
  // and so are able to filter the content across all this console
  const impersonate = localStorage.getItem('impersonate');

  if(impersonate) {

    if(debug && impersonate) {
      console.log(`Impersonating`, impersonate);
    }
    requestConfig.headers['X-Impersonated-Account'] = impersonate;
  }

  // add Authorization headers
  const idToken = await authService.getIdToken();

  if (idToken) {
    requestConfig.headers.Authorization = `Bearer ${idToken}`;
  }

  return requestConfig;
}



// WEBPACK FOOTER //
// ./src/common/api/requestInterceptor.js